import experts from '../../assets/Ourapp/experts.png'
import expertsDesktop from '../../assets/Ourapp/expertsDesktop.png'

interface ExpertsAccessProps {
  isMobile: boolean
}

const ExpertsAccess = ({ isMobile = false }: ExpertsAccessProps) => {
  return (
    <div className='w-full relative h-[660px] lg:h-auto 2xl:h-[1084px]'>
      <div
        className='absolute flex-shrink-0 left-0 z-0 bg-[#9ABDEC] h-[200px] w-[200px] blur-[50px] bottom-0
        lg:w-[452.24px] lg:h-[480px] lg:rounded-[480px] lg:top-[98px] lg:blur-[107px] lg:bottom-auto
        xl:w-[565.26px] xl:h-[600px] xl:rounded-[600px] xl:top-[123px] xl:blur-[133px]
        2xl:w-[678.31px] 2xl:h-[720px] 2xl:rounded-[720px] 2xl:top-[147px] 2xl:blur-[160px]
        3xl:w-[847.89px] 3xl:h-[900px] 3xl:rounded-[900px] 3xl:top-[184px] 3xl:blur-[200px]'
      ></div>

      <div
        className='flex flex-col lg:flex-row flex-shrink-0 justify-between items-center mx-auto z-10 p-5 gap-2 bg-white/30 backdrop-blur-[100px]
        lg:w-[964.71px] lg:h-[508.3px] lg:px-[106.67px] lg:py-[32px]  lg:rounded-l-[21px] lg:rounded-r-none
        xl:w-[1205.89px] xl:h-[636px] xl:px-[133.34px] xl:py-[40px]  xl:rounded-l-[27px] 
        2xl:w-[1447.07px] 2xl:h-[763.2px] 2xl:px-[160px] 2xl:py-[48px]  2xl:rounded-l-[32px] 
        3xl:w-[1808.83px] 3xl:h-[954px] 3xl:px-[200px] 3xl:py-[60px] 3xl:backdrop-blur-[100px] 3xl:rounded-l-[40px]
                  '
      >
        <p
          className='text-[#122D5C] font-bold tracking-wide text-lg leading-6 lg:text-xl lg:leading-8 xl:text-3xl xl:leading-10 
           2xl:text-[40px] 2xl:leading-none lg:max-w-[320px] xl:max-w-[400px]   2xl:max-w-[540px]'
        >
          Experts on-demand if you need them.
        </p>

        <img
          src={isMobile ? experts : expertsDesktop}
          className='w-[257px] h-[504px]  lg:w-[236.9px] lg:h-[465.6px] xl:w-[296.5px] xl:h-[582px] 2xl:w-[355.4px] 2xl:h-[698.4px] 3xl:w-[445px] 3xl:h-[873px] z-20
          '
        />
      </div>
    </div>
  )
}

export default ExpertsAccess
